import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import Banner from 'pages/banner'
import Dashboard from 'pages/dashboard'
import LoginPage from 'pages/login'
import NoPermission from 'pages/no-permission'
import Setting from 'pages/setting'
import StakingTokenConfig from 'pages/staking-token-config'
import FaqPage from 'pages/faq'
import FaqArticleCreatePage from 'pages/faq/article-create'
import FaqArticleDetailPage from 'pages/faq/article-detail'
import FaqArticleEditPage from 'pages/faq/article-edit'
import WhatsNewPage from 'pages/whats-new'
import { PAGES } from 'routes/index'

export const dashboardRoutes: RouteObject[] = [
  {
    path: PAGES.DASHBOARD,
    element: (
      <PrivateRoute feature={FEATURE.DASHBOARD}>
        <Dashboard />
      </PrivateRoute>
    ),
  },
]

export const settingRoutes: RouteObject[] = [
  {
    path: PAGES.SETTING,
    element: (
      <PrivateRoute feature={FEATURE.SETTING}>
        <Setting />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.STAKING_TOKEN_CONFIG,
    element: (
      <PrivateRoute feature={FEATURE.SETTING}>
        <StakingTokenConfig />
      </PrivateRoute>
    ),
  },
]

export const bannerRoutes: RouteObject[] = [
  {
    path: PAGES.BANNER,
    element: (
      <PrivateRoute feature={FEATURE.BANNER}>
        <Banner />
      </PrivateRoute>
    ),
  },
]

export const whatsNewRoutes: RouteObject[] = [
  {
    path: PAGES.WHATS_NEW,
    element: (
      <PrivateRoute feature={FEATURE.WHATS_NEW_VIEW}>
        <WhatsNewPage />
      </PrivateRoute>
    ),
  },
]

export const faqRoutes: RouteObject[] = [
  {
    path: PAGES.FAQ,
    element: (
      <PrivateRoute feature={FEATURE.FAQ_VIEW}>
        <FaqPage />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.FAQ_ARTICLE_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.FAQ_CREATE} requireCRUD>
        <FaqArticleCreatePage />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.FAQ_ARTICLE_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.FAQ_VIEW}>
        <FaqArticleDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.FAQ_ARTICLE_EDIT,
    element: (
      <PrivateRoute feature={FEATURE.FAQ_CREATE} requireCRUD>
        <FaqArticleEditPage />
      </PrivateRoute>
    ),
  },
]

export const publicRoutes: RouteObject[] = [
  {
    path: PAGES.LOGIN,
    element: <LoginPage />,
  },
  {
    path: PAGES.NO_PERMISSION,
    element: <NoPermission />,
  },
]
